import $ from 'jquery';
import {getScrollTop, onScroll} from "../utils/window";
import _ from 'lodash';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');
	const headerButton = $('.header .header_button.-type-menu');
	const menu = $('.menu');

	let lastScrollTop = 0;
	let st = 0;

	onScroll(function(event){
		let stop = getScrollTop();
		if (stop > lastScrollTop){
			// downscroll code
			//$header.addClass('is-scrolled');
			//$header.addClass('is-scroll-hide');

			if (stop <= 0) {
				//$header.removeClass('is-scroll-hide');
			}
		} else {
			// upscroll code
			if (stop <= 0) {
				//$header.removeClass('is-scrolled');
				//$header.addClass('is-scroll-start');

				setTimeout(()=>{
					//$header.removeClass('is-scroll-start');
				}, 2100);
			} else {
				if (!$header.hasClass('is-scrolled')) {
					//$header.addClass('is-scrolled');
				}
			}

			//$header.removeClass('is-scroll-hide');
		}

		lastScrollTop = stop;
	});

	if (headerToggler) {
		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);
			if (headerToggler.isOpen) {
				// $scroller.animate({ scrollTop: 0 }, { duration: 200 });

				if ($html.hasClass('is-mobile') || $html.hasClass('is-touch')) {
					st = getScrollTop();

					$scroller.css({
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%'
					});
				}
			} else {
				if ($html.hasClass('is-mobile') || $html.hasClass('is-touch')) {
					$scroller.css({
						position: '',
						top: '',
						left: '',
						width: '',
						height: ''
					});

					if (st) {
						$scroller.scrollTop(st);
						st = 0;
					} else {
						$scroller.scrollTop(0);
					}
				}
			}
		});
	}

	headerButton.click(_.debounce(function(){
		if (headerButton.hasClass('is-closed')) {

			menu.removeClass('is-opened');
			setTimeout(()=>{
				menu.removeClass('is-opening');
				setTimeout(()=>{
					menu.removeClass('is-open');
				}, 600);
			}, 500);
		} else {
			menu.addClass('is-open');
			menu.addClass('is-opening');

			setTimeout(()=>{
				menu.addClass('is-opened');
			}, 100);
		}
	}, 100));
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js